<ng-container [formGroup]="$any(controlContainer?.control)">
    @if (formElement?.elementType === FormElementType.Label) {
        <wdx-ff-label-control
            class="h-100 d-block"
            [formElement]="formElement"
        ></wdx-ff-label-control>
    }

    @if (INPUT_CONTROL_TYPES.includes($any(formElement?.fieldType))) {
        <wdx-ff-input-control
            class="h-100 d-block"
            [formElement]="formElement"
        ></wdx-ff-input-control>
    }

    @if (MULTI_SELECT_CONTROL_TYPES.includes($any(formElement?.fieldType))) {
        <wdx-ff-select
            class="h-100 d-block"
            [formElement]="formElement"
        ></wdx-ff-select>
    }

    @if (SELECT_CONTROL_TYPES.includes($any(formElement?.fieldType))) {
        @if (CHECKBOX_CONTROL_TYPES.includes($any(formElement?.elementStyle))) {
            <wdx-ff-checkboxes-control
                class="h-100 d-block"
                [formElement]="formElement"
            ></wdx-ff-checkboxes-control>
        }

        @if (
            RADIO_BUTTONS_CONTROL_TYPES.includes(
                $any(formElement?.elementStyle)
            )
        ) {
            <wdx-ff-radio-buttons-control
                class="h-100 d-block"
                [formElement]="formElement"
            ></wdx-ff-radio-buttons-control>
        }

        @if (
            !(
                CHECKBOX_CONTROL_TYPES.includes(
                    $any(formElement?.elementStyle)
                ) ||
                RADIO_BUTTONS_CONTROL_TYPES.includes(
                    $any(formElement?.elementStyle)
                )
            )
        ) {
            <wdx-ff-select
                class="h-100 d-block"
                [formElement]="formElement"
            ></wdx-ff-select>
        }
    }

    @if (DATE_CONTROL_TYPES.includes($any(formElement?.fieldType))) {
        <wdx-ff-date-control
            class="h-100 d-block"
            [formElement]="formElement"
        ></wdx-ff-date-control>
    }

    @if (FILE_UPLOAD_CONTROL_TYPES.includes($any(formElement?.fieldType))) {
        <wdx-ff-file-upload-control
            class="h-100 d-block"
            [formElement]="formElement"
            (formEvent)="formEvent.emit($event)"
        ></wdx-ff-file-upload-control>
    }

    @if (formElement?.fieldType === FormFieldType.Currency) {
        <wdx-ff-currency-control
            class="h-100 d-block"
            [formElement]="formElement"
        ></wdx-ff-currency-control>
    }

    @if (formElement?.fieldType === FormFieldType.PhoneNumber) {
        <wdx-ff-telephone-control
            class="h-100 d-block"
            [formElement]="formElement"
        ></wdx-ff-telephone-control>
    }

    @if (formElement?.fieldType === FormFieldType.RichText) {
        <wdx-ff-rich-text-control
            class="h-100 d-block"
            [formElement]="formElement"
        ></wdx-ff-rich-text-control>
    }

    @if (formElement?.fieldType === FormFieldType.Hierarchical) {
        <wdx-ff-hierarchical-control
            class="h-100 d-block"
            [formElement]="formElement"
        ></wdx-ff-hierarchical-control>
    }

    @if (formElement?.fieldType === FormFieldType.DocumentLookup) {
        @if (formElement?.lookupStyle === LookupStyle.Advanced) {
            <wdx-ff-form-wrapped-control
                class="h-100 d-block mb-1"
                [formElement]="formElement"
                [formContext]="formContext"
                [entityId]="entityId"
                [formControlName]="$any(formElement.name)"
            ></wdx-ff-form-wrapped-control>
        } @else {
            <wdx-ff-document-lookup-control
                [formElement]="formElement"
            ></wdx-ff-document-lookup-control>
        }
    }

    @if (formElement?.fieldType === FormFieldType.Boolean) {
        <wdx-ff-boolean-control
            class="h-100 d-block"
            [formElement]="formElement"
        ></wdx-ff-boolean-control>
    }

    @if (WRAPPED_CONTROL_TYPES.includes($any(formElement?.fieldType))) {
        <wdx-ff-form-wrapped-control
            class="h-100 d-block mb-1"
            [formElement]="formElement"
            [formContext]="formContext"
            [entityId]="entityId"
            [formControlName]="$any(formElement.name)"
        ></wdx-ff-form-wrapped-control>
    }

    @if (formElement?.fieldType === FormFieldType.Duration) {
        <wdx-ff-duration-control
            class="h-100 d-block"
            [formElement]="formElement"
        ></wdx-ff-duration-control>
    }
</ng-container>
